import {POPULAR_VOD_CONTEXT_MENU} from '@/constants/main';
import VodBroadcastItem from '@/components/main/MyPlus/VodBroadcastItem';
import {SoopUiSwiper} from '@/components/ui';
import {BROADCAST_TYPES} from '@/constants';

const VodDefaultTemplate = ({itemList, useSlider, log = {}}) => {
  const renderItem = () => {
    return itemList.map((broadcast, idx) => (
      <li
        key={broadcast.titleNo}
        data-type='cBox'
        data-broadcast-id={broadcast.broadNo}>
        <VodBroadcastItem
          broadcastType={BROADCAST_TYPES.VOD}
          location='myplus'
          broadcastId={broadcast.titleNo}
          authNumber={broadcast.authNo}
          vodType={broadcast.fileType}
          duration={broadcast.vodDuration}
          categoryName={broadcast.categoryName}
          categoryNo={broadcast.category}
          vodCategoryNo={broadcast.vodCategory}
          categoryTags={broadcast.categoryTags}
          autoHashTags={broadcast.autoHashtags}
          hashTags={broadcast.hashTags}
          allowsAdult={
            Number(broadcast.grade) === 19 &&
            Number(broadcast.category) === 30000
          }
          accessibleAge={Number(broadcast.grade)}
          hasBadge={true}
          thumbnailUrl={broadcast.thumbnail}
          title={broadcast.title}
          userId={broadcast.userId}
          userNickname={broadcast.userNick}
          originalUserId={broadcast.originalUserId}
          originalUserNickname={broadcast.originalUserNick}
          viewCount={broadcast.viewCnt}
          createdDate={broadcast.regDate}
          previewThumbnailUrl={broadcast.webpPath}
          listDataType={broadcast.listDataType}
          score={broadcast.score}
          contextMenu={{
            menuList: POPULAR_VOD_CONTEXT_MENU,
          }}
          log={{data: {path3: 'vod', ...log}}}
        />
      </li>
    ));
  };

  return (
    <>
      {useSlider && (
        <div className='cBox_slide'>
          <SoopUiSwiper
            swiperClass='cBox_list'
            options={{loop: itemList.length > 6}}
            maxSlidesPerView={6}
            otherMaxSlidesResolution={[
              {max: 1623, slidePerView: 6},
              {max: 1202, slidePerView: 5},
              {max: 1000, slidePerView: 4},
              {max: 751, slidePerView: 3},
              {max: 496, slidePerView: 2},
              {max: 0, slidePerView: 1},
            ]}
            swiperTag='ul'>
            {renderItem()}
          </SoopUiSwiper>
        </div>
      )}
      {!useSlider && (
        <div className='cBox-list'>
          <ul>{renderItem()}</ul>
        </div>
      )}
    </>
  );
};

export default VodDefaultTemplate;
